<template>
  
  <div class="box" style="position: relative;width: 100%;height: 100%;">
    <div class="overlay" v-if="showOverlay">
      <div class="tc">
        <div class="top">域名更替通知</div>
        <div class="text">因业务需要"河南省科技成果转移转化公共服务平台"
          原域名"http://www.nttzzc.com"改为<span style="color: blue;">"http://www.nttzzc.cn"</span>，是否直接跳转到新域名？
          <div class="btn"><el-button type="primary" @click="ToSecondIndex" >点击跳转新域名</el-button></div>
        </div>

        </div>
    </div>
  
    <el-container >
   
      <el-header
        :class="NowPath ? 'isAssume' : isRegister ? 'isResigters' : ''"
      >
        <div class="Header" :class="isRegister ? 'RegisterPage' : ''">
          <div class="Globalcontainer">
            <!-- <img src="../assets/Home/组 23378@2x.png" alt="" /> -->
             <img src="../assets/Home/组 24540@2x (1).png" alt="" />
            <div class="RightContent">
            <div style="width:100%" >
            
              <el-input
                v-show="!isRegister"
                placeholder="输入您想要搜索的内容"
                v-model="input3" style="width: 90%;"
              >
                <el-button
                  slot="append"
                  @click="ToSearch"
                  @keydown.enter.native="ToSearch()"
                  icon="el-icon-search"
                ></el-button
              ></el-input>
            </div>
              <template v-if="RealName == ''" >
                <el-button
                  type="primary"
                  class="RegisterBtn"
                  @click="OpenLogin"
                  size="small"
                  >登录</el-button
                >
                <el-button
                v-show="!isRegister"
                  type="primary"
                  class="RegisterBtn"
                  @click="toRegister"
                  size="small"
                  >注册</el-button
                >
              </template>
              <template v-else>
                <span> 您好!{{ RealName }} </span>

                <el-button
                  type="primary"
                  style="margin-left: 0.625rem"
                  @click="toManage"
                  class="RegisterBtn"
                  size="small"
                  >网上工作室</el-button
                >
                <el-button
                  type="primary"
                  class="RegisterBtn"
                  @click="Logout"
                  size="small"
                  >退出</el-button
                >
              </template>
              <h3 class="ishad" v-if="isRegister" style="cursor: pointer" @click="toIndex">
                返回首页
              </h3>
            </div>
          </div>
        </div>
        <ul v-if="!isRegister">
          <li
            v-for="(i, n) in paths"
            :key="n"
            @click="FocusNow(n, i)"
            :class="n == nowFocus ? 'isFocus' : ''"
            @mouseenter="showSpecialList(i, n)"
            @mouseleave="isShowTrue(nowFocus)"
          >
            {{ i.name }}
            <template v-if="n == 8">
              <div v-show="ShowTrue==1?true:false" class="specialList">
                <router-link @click="ShowTrue = 0" to="/contractLogin"
                  >技术合同登记</router-link
                >
                <router-link @click="ShowTrue = 0" to="/scienceLoan"
                  >科技贷</router-link
                >
                  <!-- <router-link @click="ShowTrue = false" to="/NewMap"
                >创新地图</router-link
              > -->
              </div>
            </template>
            <template v-if="n == 9">
              <div v-show="ShowTrue==2?true:false" class="specialList1">
                <router-link @click="ShowTrue = 0 ; return false" to=""
                  >政策资讯</router-link
                >
                <router-link @click="ShowTrue = 0" to=""
                  >行业活动</router-link
                >
                <router-link @click="ShowTrue = 0" to=""
                  >合作机构</router-link
                >
                 <router-link @click="ShowTrue = 0" to=""
                  >人才培训</router-link
                >
               
                <router-link @click="ShowTrue = 0" to=""
                  >自创区动态</router-link
                >
                <router-link @click="ShowTrue = 0" to=""
                  >线上直播间</router-link
                >
                <router-link @click="ShowTrue = 0" to=""
                  >全球供需对接</router-link
                >
              </div>
            </template>
          </li>
        </ul>
      </el-header>
      <el-main><router-view /></el-main>
      <el-footer :style="isRegister ? ' margin-top:80.5rem ' : ''">
        <div class="footer1">
          <div class="Globalcontainer" style="width:1500px">
            <img src="../assets/Home/组 23100@2x.png" alt="" />
            <div style="margin-right: 65px;">
              <span class="guanyu" @click="goAboutUs">关于我们</span>
              <span>|</span>
              <a :href="Urls+'/hebi.html'" target="_blank"
                >鹤壁技术转移中心</a
              >
              <span>|</span>
              <a href="https://www.hkgzyzh.cn/" target="_blank"
                >郑州航空港科技成果转移转化公共服务平台</a
              >
              <span>|</span>
              <a :href="Urls+'/ZGCcement/index.html'" target="_blank"   
                >中关村科技成果转移转化公共服务平台</a
              >
            </div>
          </div>
        </div>
        <div class="footer2">
          <div class="Globalcontainer">
            <div class="container">
              <div>
                <span> 企业邮箱 <span>hnppcjszy@163.com</span> </span>
                <span> 邮政编码 <span>450001</span> </span>
              </div>
              <div class="bottom">
                <span style="width: 21rem">
                  线上平台咨询 <span>0371-67579156</span>
                </span>

                <span>
                  单位地址
                  <span class="add"
                    >中国河南省郑州市高新技术开发区翠竹街6号</span
                  >
                </span>
              </div>
            </div>
            <div class="guanzu">
              <img
                style="width: 6.25rem; margin-bottom: 0.375rem"
                src="../assets/images/GzH.jpg"
                alt=""
              />
              <br />

              关注微信公众号
            </div>
          </div>
        </div>
        <div class="footer3">
          <a href="https://beian.miit.gov.cn/">豫ICP备18016738号-1</a>
          &nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span style="width: 20.75rem">
            技术支持： 河南八六三软件股份有限公司
          </span>
        </div>
      </el-footer>
    </el-container>
    <Login ref="login" @success="LoginSuccess" />
    <div class="sidebar">
      <Sidebar
        ref="Sidebar"
        @OpenLogin="OpenLogin"
        @toRegister="toRegister"
        @Logout="Logout"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "../components/Sidebar";
import Login from "../components/Login";
import Footer from "../components/Footer";
import { library, imgcommonUrl,WechatLogin } from "@/api/url";
import { postAction,getAction } from "@/api/api";

export default {
  name: "Home",
  components: { Login, Footer, Sidebar },
  data() {
    return {
      showOverlay: true ,// 控制遮罩层是否显示,
      input3: "",
      RealName: "",
      ShowTrue: 0,
      paths: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "技术成果库",
          path: "/fruit",
        },
        {
          name: "技术需求库",
          path: "/demand",
        },
        {
          name: "高层次人才库",
          path: "/talent",
        },
        {
          name: "创新平台",
          path: "/Organization",
        },
        {
          name: "科技活动",
          path: "/activity",
        },
        {
          name: "云展厅",
          path: "/CloudShow",
        },
        //   {
        //   name: "政策体检",
        //   path: "/qitj",
        // },
         {
          name: "创新地图",
          path: "/NewMap",
        },
        {
          name: "特色服务",
          path: "",
        },
        // {
        //   name: "高校",
        //   path: "/school",
        // },
        // {
        //   name: "流程图",
        //   path: "/flowChart",
        // },
        //  {
        //   name: "成果中关村转化郑洛新",
        //   path: "",
        // },
      ],
      nowFocus: 0, //点击的focus
      nowFocuss: 0, //移入的focus
      NowPath: false,
    };
  },
  created() {
    this.nowFocus =
      localStorage.getItem("NowIndex") == null
        ? 0
        : localStorage.getItem("NowIndex");
    this.nowFocuss = this.nowFocus;
    this.LoginSuccess(1);
    
    var location = window.location.href;

    this.NowPath = location.indexOf("/Assume") !== -1 ? true : false;
    this.isRegister = location.indexOf("/Register") !== -1 ? true : false;
    // vm.NowPath = e == "Assume" ? true : false;
    // vm.isRegister = e == "Register" ? true : false;
  },
  watch: {
    $route(to, from, next) {
      this.NowPath = to.path == "/Assume" ? true : false;
      this.isRegister = to.path == "/Register" ? true : false;
    },
  },
  mounted() {
    this.$bus.$on("ChangeFocus", (e) => {
      this.nowFocus = e;
      this.nowFocuss = e;
    });
  },
  methods: {
    ToSecondIndex() {
      window.open("http://www.nttzzc.cn");
    },
    FocusNow(n, i) {
      if (i.path !== "") {
        this.nowFocus = n;
        localStorage.setItem("NowIndex", this.nowFocus);
        this.$router.push(i.path);
      } else {
        this.nowFocus = n;
      }
    },
    isShowTrue(nowFocus, nowFocuss) {
      this.ShowTrue = 0;
      this.nowFocuss = nowFocus;
    },
    showSpecialList(i, n) {
      this.nowFocus = n;
      if (n == "8") {
        // this.nowFocus = n;
        this.ShowTrue = 1;
      } else if (n == "9"){
        this.ShowTrue = 2;
      }
    },
    ToSearch() {
      this.$router.push({ path: "/SearchData", query: { value: this.input3 } });
    },
    toIndex() {
      this.$router.push({ path: "/" });
    },
    // 登录
    OpenLogin() {
      this.$refs.login.show();
    },

    // 注册
    toRegister() {
      this.$router.push("/Register");
    },
    //登陆成功
    LoginSuccess(value) {
      let code = this.getQueryString("code");
      if(code != null && code !="" && value==1)
      {
      //this.isWeChatLogin()
      let data = {
        action: "Get_UserInfoWX",
         codeInfo:code,
      };
      postAction(library, this.$qs.stringify(data)).then((res) => {
        if(res.ID ==-1)
        {
          localStorage.setItem("UserInfo", JSON.stringify(res));
          this.$router.push("/weChatLogin");
        }
        else
        {
        this.RealName = res.RealName;
        let ID = res.ID == 0 ? "" : res.ID;
        localStorage.setItem("RealName", res.RealName);
        localStorage.setItem("RealID", ID);
        this.$refs.Sidebar.isLogin();
        }
        
      });
      // let data = {
      //   action: "Get_UserInfoWX",
      //   codeInfo:code,
      // };
      // postAction(library, this.$qs.stringify(data)).then((res) => {
       
      //   this.RealName = res.RealName;
      //   let ID = res.ID == 0 ? "" : res.ID;
      //   localStorage.setItem("RealName", res.RealName);
      //   localStorage.setItem("RealID", ID);
      //   this.$refs.Sidebar.isLogin();
      
        
      // });
      }
      else
      {
      let data = {
        action: "Get_UserInfo",
      };
      postAction(library, this.$qs.stringify(data)).then((res) => {
        this.RealName = res.RealName;
        let ID = res.ID == 0 ? "" : res.ID;
        localStorage.setItem("RealName", res.RealName);
        localStorage.setItem("RealID", ID);
        this.$refs.Sidebar.isLogin();
      });

      }
  
    },
    isWeChatLogin() {
      let code = this.getQueryString("code");
      let data = {
        action: "Weixinaccess_token",
        code: code,
      };
      getAction(WechatLogin, data).then((res) => {
        if (res.status == 1) {
          this.getwxuserinfo(res.access_token, res.openid);
        }
      });
    },
    getwxuserinfo(token, openid) {
      let data = {
        action: "getweixinuserinfo",
        openid: openid,
		accesstoken: token,
      };
      getAction(WechatLogin, data).then((res) => {
        if (res.status == 10) {
          localStorage.setItem("UserInfo", JSON.stringify(res));
          this.$router.push("/weChatLogin");
        } else if (res.status == 1) {
          localStorage.setItem("UserInfo1", JSON.stringify(res));
          var wxuserinfoupdate = res;
          wxuserinfoupdate.action = "bangdingwxuserinfo";
          getAction(WechatLogin, wxuserinfoupdate).then((res) => {});
        }
        // window.location.reload();
      });
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    //退出
    Logout() {
      let data = {
        action: "Log_Out",
      };
      postAction(library, this.$qs.stringify(data)).then((res) => {
        this.LoginSuccess(0);
        setTimeout(() => {
          this.$bus.$emit("LoginSuccess", true);
        }, 200);
      });
    },
    toManage() {
      window.parent.location.href = imgcommonUrl + "/Manage/Index.aspx";
    },
    //跳转关于我们页面
    goAboutUs() {
      this.$router.push("/aboutUs");
    },
     getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
  },
};
</script>
<style lang='scss' scoped>
.tc{
  background-color: #fff;
  width: 30rem;
  height: 25rem;
  border-radius: 4px;
  z-index: 1001; /* 内容层在遮罩层之上 */
  .top{
    width: 30rem;
    height: 6rem;
   background-image: url("../assets/Home/蒙版组 285@2x.png");
   text-align: center;
   font-size: 1.6rem;
   font-weight: bolder;
   color: #fff;
   padding-top: 3rem;
   background-size: cover; /* 覆盖整个容器 */
  background-position: center; /* 背景图片居中 */
  }
  .text{
    width: 26rem;
    height: 25rem;
    line-height: 1.5rem;
    padding: 2rem;
    .btn{
      margin-top: 4rem;
    }
  }
}
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明遮罩层 */
  z-index: 1000; /* 确保遮罩层在内容之上 */
}
.sidebar {
  width: 5rem;
  height: 37rem;
  position: fixed;
  right: 0;
  bottom: 2rem;
  
}
.el-header {
  padding: 0;
  height: 14.875rem !important;
  ul {
    height: 6.25rem;
    background: linear-gradient(270deg, #005cce 0%, #409aff 100%);
    padding: 0 16.25rem;
    font-size: 1.375rem;
    display: flex;
    justify-content: space-around;
    line-height: 6.25rem;
    margin: 0;
    li {
      color: #fff;
      padding: 0 1.0625rem;
      cursor: pointer;
    }
  }
}
.isResigters {
  height: 26.375rem !important;
}
.Header {
  background-image: url("../assets/Home/组 20@2x.png");
  height: 8.75rem;
  background-size: 100% 100%;
  div {
    padding-top: 1.875rem;
    img {
      width: 33.5625rem;
      height: auto;
    }
    /deep/ .el-input-group__append {
      background: #5599ff;
      color: #fff;
      border: 0.0625rem solid #5599ff;
    }
  }
}

.el-footer {
  height: 26rem !important;
  padding: 0;
  margin: 0;

  background: #222a3d;
  .footer1 {
    height: 6.875rem;
    background: rgba(63, 73, 97, 0.48);

    div {
      padding-top: 1.25rem;
      img {
        width: 32rem;
      }
      div {
        margin-top: -2rem;
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.5);
        span {
          cursor: pointer;
          margin: 0 .9375rem;
        }
        a {
          font-size: 1rem;
          color: rgba(255, 255, 255, 0.5);
        }
      }
    }
  }
  .footer2 {
    .Globalcontainer {
      font-size: 0.875rem;
      color: rgba(255, 255, 255, 0.5);
      height: auto;
      padding: 3.5625rem 0 3.1875rem 0;
      border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.2);
      .container {
        height: 5.0625rem;
        width: 52.1875rem;
        text-align: left;
        display: flex;
        div {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          span {
            min-width: 15.25rem;
            display: inline-block;
            span {
              display: inline;
              font-size: 1.25rem;
              color: #fff;
              font-weight: 500;
              margin-left: 1.25rem;
            }
          }
        }
      }
      .guanzu{
        margin-right: 1.875rem;
      }
    }
  }
  .footer3 {
    font-size: 1rem;
    font-family: PingFangSC-Regular;
    height:4.1875rem;
    line-height: 4.1875rem;
    color: #ffffff;
    opacity: 0.5;
    a {
      color: #ffffff;
    }
  }
}
.isFocus {
  height: 6.25rem;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  position: relative;
}
.RightContent {
  display: flex;
  font-size: 0.875rem;
  width: 600px;
  color: #fff;
  align-items: center;
  padding: 0 !important;
  h3 {
    margin-left: 3.125rem;
  }
  div {
    padding: 0;
  }
  span {
    width: 8.75rem;
    margin-left: 1.25rem;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .RegisterBtn {
    background: transparent;
    border: 0.0625rem solid #ffffff;
    border-radius: 0.3125rem;
  }
}
.isAssume {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  .Header,
  ul {
    background: transparent;
  }
}
.RegisterPage {
  height: 26.375rem;
  background: url("../assets/images/Header.png");
  background-size: 100% 100%;
}
.specialList {
  width: 7.6875rem;
  height: 9rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 0.375rem rgba(0, 0, 0, 0.16);
  position: absolute;
  left: 0;
  z-index: 99;
  top: 6.125rem;
  a {
    text-decoration: none;
    color: #333;
    display: block;
    font-size: 1.125rem;
    line-height: 4rem;
  }
  a:hover {
    background: #f6f6f6;
  }
}
.specialList1 {
  width: 15.7875rem;
  height: 28rem;
  background: #ffffff;
  box-shadow: 0rem 0.1875rem 0.375rem rgba(0, 0, 0, 0.16);
  position: absolute;
  left: 0;
  z-index: 99;
  top: 6.125rem;
  a {
    text-decoration: none;
    color: #333;
    display: block;
    font-size: 1.125rem;
    line-height: 4rem;
  }
  a:hover {
    background: #f6f6f6;
  }
}
.add {
  color: #fff;
  font-size: 1.25rem;
}
@media (max-width: 1400px) {
  .Header {
    // div {
    //   width: 100%;
    //   box-sizing: border-box;
    //   padding-left: 1.25rem;
    //   padding-right: 1.25rem;
      // div {
      //   width: auto;
      // }
    // }
  }
}
.ishad{
  font-size:1.5rem;
  font-weight: bold;
  font-family: Microsoft YaHei;
}
.guanyu{
  margin: 0 !important;
}
</style>
